import { Stack, Typography, useTheme } from "@mui/material";
import { EditListIcon } from "components/icons";

type LegacySlaStatus = "Expired" | "Warning" | "Open";
type NewSlaStatus =
  | "on_track"
  | "paused"
  | "at_risk"
  | "breached"
  | "met"
  | "pending"
  | "disabled";
type SlaStatusType = LegacySlaStatus | NewSlaStatus;

const STATUS_LABELS: Record<string, string> = {
  on_track: "On Track",
  paused: "Paused",
  at_risk: "At Risk",
  breached: "Breached",
  met: "Met",
  pending: "Pending",
  Open: "Open",
  Warning: "Warning",
  Expired: "Expired",
};

export const SlaStatusBadge = ({
  type,
  showSlaText = true,
}: {
  type: SlaStatusType;
  showSlaText?: boolean;
}) => {
  const theme = useTheme();

  const getColor = () => {
    switch (type) {
      // New SLA statuses
      case "on_track":
      case "met":
      case "Open":
        return theme.palette.success;
      case "at_risk":
      case "Warning":
        return theme.palette.warning;
      case "breached":
      case "Expired":
        return theme.palette.error;
      case "paused":
      case "pending":
        return theme.palette.info;
      default:
        return theme.palette.success;
    }
  };

  const color = getColor();

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      bgcolor={color?.tint}
      sx={{
        padding: "4px 12px 4px 8px",
        borderRadius: "4px",
        minWidth: "84px",
        border: "0px",
      }}
      gap="4px"
    >
      <EditListIcon htmlColor={color?.main} fontSize="small" />
      <Typography variant="caption-3" color={theme.palette.lightBg.high}>
        {showSlaText ? "SLA : " : ""}
        <span style={{ textTransform: "capitalize" }}>
          {STATUS_LABELS[type] || type}
        </span>
      </Typography>
    </Stack>
  );
};
